import { MapCompany } from "@/types/company";
import { companiesApi } from "@/lib/api/apiwrapper";

export async function fetchCompanyMetaData(year?: number | null) {
  const response = await companiesApi.companiesGetCompanyMetadataGET({ year: year ?? undefined });

  return response;
}

export async function fetchCompaniesByBoundingBox(bbox: number[][], filters: { categories: string[]; totalOrderAmount: { min?: number; max?: number }; year?: number | null }): Promise<MapCompany[]> {
  const [southWest, northEast] = bbox;
  const [minLon, minLat] = southWest;
  const [maxLon, maxLat] = northEast;

  const dtos = await companiesApi.companiesGetCompaniesByBoundingBoxGET({
    minLat,
    maxLat,
    minLon,
    maxLon,
    categoriesEN: filters.categories.length ? filters.categories.join(",") : undefined,
  });

  let mapped: MapCompany[] = dtos.map((c: any) => {
    let coordinates: any = null;
    try {
      coordinates = c.osmBuilding?.coordinates ? JSON.parse(c.osmBuilding.coordinates) : null;
    } catch {
      coordinates = null;
    }

    const company: MapCompany = {
      id: c.id,
      name: c.name,
      description: c.description ?? null,
      address: {
        street: c.street ?? "",
        number: c.number ?? "",
        postalCode: c.postalCode ?? "",
        city: c.city ?? "",
        country: c.country ?? "",
      },
      osmBuilding: c.osmBuilding
        ? {
            geometryType: c.osmBuilding.geometryType,
            coordinates: coordinates ?? [],
            building: c.osmBuilding.building ?? undefined,
            image: c.osmBuilding.image ?? undefined,
            mapillary: c.osmBuilding.mapillary ?? undefined,
            refBag: c.osmBuilding.refBag ?? undefined,
            source: c.osmBuilding.source ?? undefined,
            sourceDate: c.osmBuilding.sourceDate ?? undefined,
            startDate: c.osmBuilding.startDate ?? undefined,
            wikidata: c.osmBuilding.wikidata ?? undefined,
            wikipedia: c.osmBuilding.wikipedia ?? undefined,
            isHighlighted: c.osmBuilding.isHighlighted ?? false,
          }
        : null,
      orders: [],
      meta: {
        name: c.name,
        description: c.description ?? null,
        totalOrderAmount: 0,
        totalOrderCount: 0,
        rank: 0,
      },
    };

    return company;
  });

  if (filters.totalOrderAmount.min || filters.totalOrderAmount.max) {
    const metaData = await fetchCompanyMetaData(filters.year);
    const companiesMeta = metaData.companies ?? {};

    mapped = mapped.filter((company: any) => {
      const meta = companiesMeta[company.id];
      if (!meta) return false;

      const amount = meta.totalOrderAmount ?? 0;

      return amount >= (filters.totalOrderAmount.min ?? 0) && amount <= (filters.totalOrderAmount.max ?? Infinity);
    });
  }

  return mapped;
}
